module.exports = __webpack_public_path__ + "static/media/ic_logo_antai.86e2251a.jpg";